module.exports = {
  MDSStreamingAPI: "",
  MDSSnapshotAPI: "wss://ttl2aacloud01.tx-tech.com/snapshot/pubsub",
  MDSOthersAPI: "wss://ttl2aacloud01.tx-tech.com/info/pubsub",
  MDSProxyAPI: "ws://10.98.30.107:9996/pubsub",
  MDSEntityKey: "EIF",
  MDSSuperkey: "eifhk2txtech1keyencrypt20key0729",
};
